<template>
	<Skeleton :paragraph="{ rows: 6 }" :title="false" :loading="loading">
		<VerticalLayout>
			<TypographyParagraph strong>
				{{ $t('settings.vrsSettingsForm.serviceTitle') }}:
				{{ serviceName }}
			</TypographyParagraph>
			<LabeledSwitch
				v-model="allowReadOnlyUnauthorizedAccess"
				:rightLabel="$t('settings.vrsSettingsForm.allowReadOnlyUnauthorizedAccess')"
				@change="onUpdateField('allowReadOnlyUnauthorizedAccess', $event)"
			/>
			<LabeledSwitch
				v-model="showMountpointsForUnauthorizedUsers"
				:rightLabel="$t('settings.vrsSettingsForm.showMountpointsForUnauthorizedUsers')"
				@change="onUpdateField('showMountpointsForUnauthorizedUsers', $event)"
			/>
			<LabeledSwitch
				v-model="nearEnabled"
				:rightLabel="$t('settings.vrsSettingsForm.nearEnabled')"
				@change="onUpdateField('nearEnabled', $event)"
			/>
			<LabeledSwitch
				v-model="otlEnabled"
				:rightLabel="$t('settings.vrsSettingsForm.otlEnabled')"
				@change="onUpdateField('otlEnabled', $event)"
			/>
			<RadioGroup v-model:value="localeSelected" class="pd-md-vertical" :options="localeOptions" option-type="button" />
			<TypographyParagraph
				v-if="sessionStore.debug"
				type="secondary"
			>
				{{ $t('settings.vrsSettingsForm.specialModesMenuHint') }}
			</TypographyParagraph>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="debugModeEnabled"
				:rightLabel="$t('settings.vrsSettingsForm.debugMode')"
				@change="onUpdateField('debugModeEnabled', $event)"
			/>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="ignoreLiveCasterStat"
				:rightLabel="$t('settings.vrsSettingsForm.ignoreLiveCasterStat')"
				@change="onUpdateField('ignoreLiveCasterStat', $event)"
			/>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="ignoreLiveCasterStats"
				:rightLabel="$t('settings.vrsSettingsForm.ignoreLiveCasterStats')"
				@change="onUpdateField('ignoreLiveCasterStats', $event)"
			/>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="ignoreVrsStats"
				:rightLabel="$t('settings.vrsSettingsForm.ignoreVrsStats')"
				@change="onUpdateField('ignoreVrsStats', $event)"
			/>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="ignoreNearStats"
				:rightLabel="$t('settings.vrsSettingsForm.ignoreNearStats')"
				@change="onUpdateField('ignoreNearStats', $event)"
			/>
			<LabeledSwitch
				v-if="sessionStore.debug"
				v-model="ignoreConfigUpdate"
				:rightLabel="$t('settings.vrsSettingsForm.ignoreConfigUpdate')"
				@change="onUpdateField('ignoreConfigUpdate', $event)"
			/>
		</VerticalLayout>
	</Skeleton>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { Skeleton, RadioGroup, TypographyParagraph } from 'ant-design-vue';

import { localeSettings } from '@/locales/locales';

import { useSessionStore } from '@/stores/session';

import LabeledSwitch from '@/components/common/LabeledSwitch.vue';
import VerticalLayout from '@/components/common/VerticalLayout.vue';

export default {
	components: {
		RadioGroup, Skeleton, LabeledSwitch, VerticalLayout, TypographyParagraph,
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		settings: {
			type: Object,
			default: null,
		},
		onUpdateField: {
			type: Function,
			required: true,
		},
	},
	setup(props) {
		const allowReadOnlyUnauthorizedAccess = ref(false);
		const showMountpointsForUnauthorizedUsers = ref(false);
		const nearEnabled = ref(false);
		const otlEnabled = ref(true);
		const debugModeEnabled = ref(false);
		const ignoreLiveCasterStat = ref(false);
		const ignoreLiveCasterStats = ref(false);
		const ignoreVrsStats = ref(false);
		const ignoreNearStats = ref(false);
		const ignoreConfigUpdate = ref(false);
		const sessionStore = useSessionStore();
		const localeSelected = computed({
			get: () => sessionStore.locale,
			set: value => sessionStore.updateLocale(value),
		});
		const localeOptions = ref(localeSettings);
		const serviceName = computed(() => sessionStore.projectTitle);

		watch(() => props.settings, value => {
			allowReadOnlyUnauthorizedAccess.value = value.allowReadOnlyUnauthorizedAccess;
			showMountpointsForUnauthorizedUsers.value = value.showMountpointsForUnauthorizedUsers;
			nearEnabled.value = value.nearEnabled;
			otlEnabled.value = value.otlEnabled;
			debugModeEnabled.value = value.debugModeEnabled;
			ignoreLiveCasterStat.value = value.ignoreLiveCasterStat;
			ignoreLiveCasterStats.value = value.ignoreLiveCasterStats;
			ignoreVrsStats.value = value.ignoreVrsStats;
			ignoreNearStats.value = value.ignoreNearStats;
			ignoreConfigUpdate.value = value.ignoreConfigUpdate;
		});

		return {
			allowReadOnlyUnauthorizedAccess,
			showMountpointsForUnauthorizedUsers,
			nearEnabled,
			otlEnabled,
			debugModeEnabled,
			ignoreLiveCasterStat,
			ignoreLiveCasterStats,
			ignoreVrsStats,
			ignoreNearStats,
			ignoreConfigUpdate,
			localeSelected,
			localeOptions,
			sessionStore,
			serviceName,
		};
	},
}
</script>
